import {unitsActionTypes as types} from 'actions/actionTypes';

export default function units(state = [], action) {
  switch (action.type) {
    case types.LOAD_UNITS_SUCCESS: {
      return [...action.units];
    }
    case types.NEW_UNIT_ADDED: {
      return [action.unit, ...state];
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/unitsReducer.js